export default {
  decodeUrl(urlString) {
    if (urlString.includes('%')) {
      return this.decodeUrl(decodeURIComponent(urlString));
    }
    return urlString;
  },
};
